import { FeedItem } from '../../Api'

export const getPartnerLabel = (feedItem: FeedItem) => {
  if (feedItem.partnerId) return feedItem.partnerId
  if (feedItem.tags?.find((tag) => tag === 'wll')) return 'WLL'
  return 'PLL'
}